import { Segmented } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useRef } from "react";
import "./segment.css";

const ScrollableSegmented = ({ options, activeTab, setActiveTab }) => {
    const scrollRef = useRef(null);

    const scroll = (direction) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === "left" ? -150 : 150,
                behavior: "smooth",
            });
        }
    };

    return (
        <div className="segmented-scroll-wrapper">
            <button className="scroll-btn left" onClick={() => scroll("left")}>
                <LeftOutlined style={{fontSize:"14px"}}/>
            </button>

            <div className="segmented-scroll-container" ref={scrollRef}>
                <Segmented
                    options={options}
                    value={activeTab}
                    onChange={setActiveTab}
                    className="custom-segmented"
                />
            </div>

            <button className="scroll-btn right" onClick={() => scroll("right")}>
                <RightOutlined  style={{fontSize:"14px"}}/>
            </button>
        </div>
    );
};

export default ScrollableSegmented;
